import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { LibDocumentationComponent } from '@pishgamrayan/ng-api-documentation';
import { AppIntroService } from 'src/app/layout/components/app-intro/app-intro.service';

@Component({
  selector: 'documentation',
  standalone: true,
  templateUrl: './documentation.component.html',
  imports: [LibDocumentationComponent],
  changeDetection: ChangeDetectionStrategy.Default,
  styles: `
    ::ng-deep documentation {
      .sidebar-container {
        a {
          min-height: 45px !important;
          &:hover {
            color: #aab3e8 !important;
          }
        }
      }
    }
    :host ::ng-deep {
      label.input input {
        &:focus,
        &:focus-visible {
          outline: none !important;
          box-shadow: none !important;
          animation: none !important;
        }
      }
    }
  `,
})
export class DocumentationComponent {
  private appIntroService = inject(AppIntroService);

  constructor() {
    this.appIntroService.setVisible(false);
    this.appIntroService.destroy();
  }
}
